import { render, staticRenderFns } from "./ModalAddTarifKarbaran.vue?vue&type=template&id=01ef5122&scoped=true&"
import script from "./ModalAddTarifKarbaran.vue?vue&type=script&lang=js&"
export * from "./ModalAddTarifKarbaran.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddTarifKarbaran.vue?vue&type=style&index=0&id=01ef5122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ef5122",
  null
  
)

export default component.exports